import { render, staticRenderFns } from "./ShortlistedScreen.vue?vue&type=template&id=c8b3dd66"
import script from "./ShortlistedScreen.vue?vue&type=script&lang=js"
export * from "./ShortlistedScreen.vue?vue&type=script&lang=js"
import style0 from "./ShortlistedScreen.vue?vue&type=style&index=0&id=c8b3dd66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports